document.addEventListener("click", (e) => {
  const link = e.target.closest(
    ".menu-drawer__list-item--flat > a.menu-drawer__menu-item--mainlist"
  );
  if (!link) return;

  const li = link.closest(".menu-drawer__list-item--flat");
  const submenu = li.querySelector(":scope > .menu-drawer__menu--childlist");
  if (!submenu) return; // normal links should work

  e.preventDefault();

  // close all other open items
  document
    .querySelectorAll(".menu-drawer__list-item--flat.is-open")
    .forEach((openLi) => {
      if (openLi !== li) openLi.classList.remove("is-open");
    });

  // toggle current
  li.classList.toggle("is-open");
});
